import React, { FC } from 'react';

import { useProductListFilters } from '@hooks/products-list-fiters';

import { CategoryCheckboxGroup } from '@components/catalog/CategoryCheckboxGroup/CategoryCheckboxGroup';
import { CategoryFiltersAccordion } from '@components/catalog/CategoryFiltersAccordion/CategoryFiltersAccordion';
import { CategoryPriceRangeFilter } from '@components/catalog/CategoryPriceRangeFilter/CategoryPriceRangeFilter';
import { Button } from '@components/common/Button/Button';
import { Drawer } from '@components/common/Drawer/Drawer';
import { StyledScrollArea } from '@components/common/StyledScrollArea/StyledScrollArea';
import { CloseIcon } from '@components/icons';

import styles from './CategoryFiltersDrawer.module.scss';

export type CategoryFiltersDrawerProps = {
    isOpen: boolean;
    onOpenChange: (isOpen: boolean) => void;
};

export const CategoryFiltersDrawer: FC<CategoryFiltersDrawerProps> = (props) => {
    const { onOpenChange } = props;

    const { checkboxFilters, accordionFilters, applyFilters, discardFilters } =
        useProductListFilters();

    const handleCloseDrawer = () => {
        onOpenChange(false);
    };

    const handleApplyFilters = () => {
        applyFilters();
        handleCloseDrawer();
    };

    const handleDiscardFilters = () => {
        discardFilters();
        handleCloseDrawer();
    };

    return (
        <Drawer title="Фильтры" {...props}>
            <StyledScrollArea classes={{ viewport: styles.scrollAreaViewport }}>
                {checkboxFilters.length > 0 && (
                    <>
                        <CategoryCheckboxGroup data={checkboxFilters} variant="secondary" />
                        <hr className={styles.separator} />
                    </>
                )}
                <CategoryPriceRangeFilter variant="secondary" />
                <hr className={styles.separator} />
                {(accordionFilters.countries.length > 0 ||
                    accordionFilters.manufacturers.length > 0) && (
                    <CategoryFiltersAccordion data={accordionFilters} variant="secondary" />
                )}
            </StyledScrollArea>
            <div className={styles.controls}>
                <Button onClick={handleApplyFilters} variant="green" isFullWith>
                    Применить
                </Button>
                <Button
                    variant="white"
                    isFullWith
                    icon={CloseIcon}
                    className={styles.resetButton}
                    classes={{ icon: styles.resetIcon }}
                    onClick={handleDiscardFilters}
                >
                    Сбросить фильтры
                </Button>
            </div>
        </Drawer>
    );
};
